// These should match the names of events that Twilio sends us
export enum ConversationEvent {
    ON_CONVERSATION_ADDED = 'onConversationAdded',
    ON_MESSAGE_ADDED = 'onMessageAdded',
    RESERVATION_CREATED = 'ReservationCreated',
}

/**
 * The possible states searching for an expert
 * @property {string} PRE_LOADING - wait status before the initial search
 * @property {string} FIND_INITIAL_EXPERT - initial search for the next available expert
 * @property {string} FIND_NEW_EXPERT_NEGLECTION - searching for a new expert after a neglection
 * @property {string} FIND_NEW_EXPERT_QUEUE_CHANGE - searching for an expert in a new queue
 * @property {string} FIND_NEW_EXPERT_ESCALATION - searching for an escalated expert
 * @property {string} SEARCH_COMPLETE - searching is complete
 * @readonly
 */
export const ExpertSearchStates = {
    PRE_LOADING: 'PreLoading',
    FIND_INITIAL_EXPERT: 'SearchingForNextAvailableExpert', // backwards compatible string value
    FIND_NEW_EXPERT_NEGLECTION: 'SearchingForNewExpertFromNeglection',
    FIND_NEW_EXPERT_QUEUE_CHANGE: 'SearchingForExpertInNewQueue',
    FIND_NEW_EXPERT_ESCALATION: 'SearchingForEscalatedExpert',
    SEARCH_COMPLETE: 'FoundAvailableExpert', // backwards compatible string value
} as const;

export type ExpertSearchStates = (typeof ExpertSearchStates)[keyof typeof ExpertSearchStates];

export enum UserAgent {
    Customer = 'customer',
    Expert = 'expert',
    Bot = 'bot',
    System = 'system',
}

export enum TriggeredMessageTypes {
    CUSTOMER_DECLINED = 'customerDeclined',
    SALES_DISCLOSURE = 'salesDisclosure',
    ENABLE_ENROLLMENT = 'enableEnrollment',
    // ! NOTE: All expert only messages should start with expertOnly in order to properly display on customer sdk
    EXPERT_ONLY = 'expertOnly',
    EXPERT_ONLY_NEGLECTION = 'expertOnlyNeglection',
    EXPERT_ONLY_AUTOPILOT_STARTED = 'expertOnlyAutopilotStarted',
}

export enum StepNames {
    GREETING_BOT = 'GreetingBot',
    ADD_MDN = 'AddMDN',
    ADD_OTP = 'AddOTP',
    SEND_TO_FLEX_SERVICE = 'SendToFlexService',
    PRESENCE_VERIFIER_BOT = 'PresenceVerifierBot',
    AUTOPILOT_BOT = 'AutopilotBot',
}

export enum BotFlowVersion {
    BOT_FLOW_V1 = 'BotFlowV1',
    BOT_FLOW_V2 = 'BotFlowV2',
}

export enum StateMachineActionTask {
    GoBack = 'go back',
    SkipOtp = 'skip otp',
}

export enum UpdateConversationPropertyName {
    ProblemStatement = 'problemStatement',
    AddMdn = 'addMdn',
    AddOtp = 'addOtp',
    FirstName = 'firstName',
}

/**
 * @depreciated this type should not be used and will be removed in the future
 * remnant of the old bot system built in twilio flows
 */
export enum BotType {
    MoreDetailsBot = 'more_details_bot',
    RoutingBot = 'routing_to_expert_bot',
}
